module.exports = __webpack_public_path__ + "static/media/booster.a4f297c5.svg";